import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../security/auth.service';
import { LogService } from '../services/log/log.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  private readonly securityService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly logger = inject(LogService);

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    // Get property name on security object to check
    const claimType: string = next.data['claimType'];

    this.logger.debug(
      'hasClaim',
      claimType,
      this.securityService.hasClaim(claimType),
    );

    if (
      this.securityService.isAuthenticated() &&
      (this.securityService.hasClaim(claimType) || !claimType)
    ) {
      return true;
    }

    const redirectUrl = next.data['redirect'] ?? 'login';

    this.router.navigate([redirectUrl], {
      queryParams: { returnUrl: state.url },
    });
    return false;
  }
}
